import * as Sentry from "@sentry/react"

const dsn = import.meta.env.VITE_SENTRY_DSN

if (dsn) {
	Sentry.init({
		dsn,
		release: import.meta.env.VITE_SENTRY_RELEASE,
		environment: import.meta.env.MODE,
		integrations: [Sentry.browserTracingIntegration()],
		tracesSampleRate: 1.0,
	})
}
